import React, { useEffect } from 'react';
import { NotificationWrapper, NotificationCloseButton } from '../../style/StyledElement';

const Notification = ({ type, children, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(onClose, 3000); // Auto-close after 3 seconds
      return () => clearTimeout(timer);
    }, [onClose]);
  
    return (
      <NotificationWrapper type={type}>
        {children}
        <NotificationCloseButton onClick={onClose}>X</NotificationCloseButton>
      </NotificationWrapper>
    );
  };
  

export default Notification;